import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { filter } from 'rxjs';
import { WorklogService } from 'src/app/module/budgets/services/worklog.service';
import { EmsServicesService } from 'src/app/module/ems-master/services/pms-services.service';
import { SharedService } from 'src/app/shared/shared.service';
import { TabService } from 'src/app/shared/tab.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent {
  @Input() warehouseList: any[] = [];
  @Input() accounts: any[] = [];
  @Input() showCustomer: boolean = false;
  @Input() showWarehouse: boolean = false;
  @Input() showCustomerAndWarehouse: boolean = false;
  @Input() showStatus?: boolean;
  @Input() showZone: boolean = false;
  @Input() showDepartment: boolean = false;
  @Input() showDesignation: boolean = false;
  @Input() showEmpName: boolean = false;
  @Input() showLocationName: boolean = false;
  @Input() showEmpCode: boolean = false;
  @Input() showProjectOwner: boolean = false;
  @Input() showProjectManager: boolean = false;
  @Input() showHod: boolean = false;
  @Input() showProject: boolean = false;
  @Input() showEmployee: boolean = false;
  @Input() showProjectCategory: boolean = false;
  @Input() showLocationType: boolean = false;
  @Input() showPriority: boolean = false;
  @Input() showDateFilter: boolean = false;
  @Input() showWorklogStatus: boolean = false;
  @Input() showProjectStatus: boolean = false;
  @Input() showCity: boolean = false;
  @Input() showRegion: boolean = false;
  @Input() showExpenseType: boolean = false;
  @Input() showFY: boolean = false;
  @Input() showMonth: boolean = false;
  @Input() showBillingType: boolean = false;
  @Input() showUnitsOfMeasurement: boolean = false;
  @Input() showExpensesHead: boolean = false;
  @Input() showInvoiceStatus: boolean = false;
  @Input() showVendor: boolean = false;
  @Input() showCategory: boolean = false;
  // Output events to notify parent component
  @Output() filterChange = new EventEmitter<any>();
  @Output() resetFilters = new EventEmitter<void>();

  searchForm: FormGroup;
  searchDropDownToggle: boolean = false

  category: any;
  clientId: any;
  customerModel: any;
  warehouseFilter: any = [];
  selectedCategories: any[] = []
  tabFilter: any
  allCatagory:any;
  sendCatagoryId:any;
  zoneList:any;
  designationList:any;
  departmentList:any;
  priorityList:any;
  regionList:any;
  cityList:any;
  expenseTypeList:any;
  financialYearList:any;
  date: Date[] | undefined;
  wareHouseList:any;
  accountMappingList:any;
  employeeLists:any[]=[];
  projectLists:any[]=[];
  categoryList:any;
  projectCategoryList:any[]=[]
  locationTypeList:any[]=[]
  worklogStatus:any[]=[];
  projectStatus:any[]=[];
  role:any;
  selectedOption :any = "";
  showCustomDateRange: boolean = false;
  constructor(private tabService: TabService,private emsServices: EmsServicesService,private sharedService: SharedService,private worklogService: WorklogService) {
    this.searchForm = new FormGroup({
      ACCOUNT_ID_IN: new FormControl(''),
      MAPPING_IN: new FormControl(''),
      WAREHOUSE_ID_IN: new FormControl(''),
      STATUS_IN: new FormControl(''),
      ZONE_IN: new FormControl(''),
      DEPARTMENT_ID_IN: new FormControl(''),
      DESIGNATION_IN: new FormControl(''),
      CATEGORY_IN: new FormControl(''),
      PROJECT_CODE_IN: new FormControl(''),
      LOCATION_TYPE_IN: new FormControl(''),
      NAME_IN:  new FormControl(''),
      LOCATION_NAME_IN: new FormControl(''),
      EMPLOYEE_CODE: new FormControl(''),
      EMPLOYEE_ID_IN: new FormControl(''),
      USER_ID_IN: new FormControl(''),
      HOD_ID_IN: new FormControl(''),
      USER_ID: new FormControl(''),
      PRIORITY_ID_IN: new FormControl(''),
      REGION_IN: new FormControl(''),
      CITY: new FormControl(''),
      EXPENSE_TYPE_IN: new FormControl(''),
      YEAR_IN: new FormControl(''),
      DUMMY_FILTER_TWO: new FormControl(''), // DUMMY_FILTER_TWO IS USED FOR MONTH
      FROM_DATE: new FormControl(''),
      TO_DATE: new FormControl(''),
      BILLINGTYPE: new FormControl(''),
      UNITOFMEASUREMENT: new FormControl(''),
      EXPENSESHEAD: new FormControl(''),
      INVOICESTATUS: new FormControl(''),
      VENDOR: new FormControl(''),
      CUSTOMER: new FormControl(''),
      DUMMY_FILTER_ONE: new FormControl()  // DUMMY_FILTER_ONE IS USED FOR DATE FILTER 
    });
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!)
    this.categoryList = JSON.parse(localStorage.getItem('category')!)
    this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
    this.role = JSON.parse(localStorage.getItem('role')!);
    this.sendCatagoryId = this.setId()
    console.log(this.sendCatagoryId,'this.sendCatagoryId')
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())
  }

  ngOnInit(): void {
    if(this.showExpenseType){
      this.getExpenseList()
    }
    if(this.showWarehouse){
      this.getWarehouseList()
    }
    if(this.showProjectOwner || this.showProjectManager || this.showHod || this.showEmployee){
      this.getEmployeeList()
    }
    if(this.showProject){
      this.getProjectList()
    }
    if(this.showWorklogStatus){
      this.getWorklogStatus()
    }
    if(this.showProjectStatus){
      this.getProjectMasterStatusList()
    }
    const categoryData = JSON.parse(localStorage.getItem('category')!);
    if (categoryData.length>0) {
      this.category = categoryData;
    }

    // Tab service
    const activeTabIndex = this.tabService.activeTab;
    const activeTab = this.tabService.tabs[activeTabIndex];
    if (activeTab?.filterData) {
      this.warehouseFilter = activeTab.filterData;
      
      this.tabFilter = this.tabService.transformFiltersArrayToObject(activeTab.filterData);
      this.searchForm.patchValue(activeTab.filterData);
      const categoryFilter = this.tabFilter

      Object.entries(categoryFilter).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          if (typeof value === 'string') {
            // Ensure only numeric values are converted to numbers
            if (!isNaN(Number(value)) && value.trim() !== "") {
              this.searchForm.get(key)?.setValue(value.split(',').map(val => Number(val)));
            } else {
              this.searchForm.get(key)?.setValue(value); // Keep string values as-is
            }
          } else if (typeof value === 'number') {
            this.searchForm.get(key)?.setValue(value);
          } else if (Array.isArray(value)) {
            this.searchForm.get(key)?.setValue(value.map(val => (isNaN(Number(val)) ? val : Number(val))));
          }
        }
        if(key === 'MAPPING_IN'){
          const data = Number(value)
          this.searchForm.controls['MAPPING_IN'].setValue(data)
        }
        if(key === 'DUMMY_FILTER_TWO'){
          if (value) {
            const date = new Date(value as string | number);
            if (!isNaN(date.getTime())) {
              this.searchForm.controls['DUMMY_FILTER_TWO'].setValue(date);
            }
          }
        }
        if(key === 'DUMMY_FILTER_ONE'){
          if(value){
            this.selectedOption = value
            if(this.selectedOption === 'custom'){
              this.showCustomDateRange = true
              if(this.searchForm.controls['FROM_DATE'].value){
                const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['FROM_DATE'].value);
                this.searchForm.controls['FROM_DATE'].setValue(formattedDate)
              }
              if(this.searchForm.controls['TO_DATE'].value){
                const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['TO_DATE'].value);
                this.searchForm.controls['TO_DATE'].setValue(formattedDate)
              }
            }
            else{
              if(this.searchForm.controls['FROM_DATE'].value){
                const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['FROM_DATE'].value);
                this.searchForm.controls['FROM_DATE'].setValue(formattedDate)
              }
              if(this.searchForm.controls['TO_DATE'].value){
                const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['TO_DATE'].value);
                this.searchForm.controls['TO_DATE'].setValue(formattedDate)
              }
            }
          }
        }
      });
      console.log(this.searchForm)
      this.filterChange.emit(activeTab.filterData);
    }
    this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : ''
  }

  handleEnter(event: any) {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
      this.onSubmit();
    }
  }

  onSubmit() {
    // this.searchForm.removeControl('WAREHOUSEMAPPING')
    // this.searchForm.controls['MONTH'].setValue('')
    const formattedFilters = Object.entries(this.searchForm.value).reduce<any[]>((acc, [key, value]) => {
      if (value || value === 0) {
        if (key === 'FROM_DATE' || key === 'TO_DATE') {
          acc.push({
            key: key,
            dateTimeValue: moment(value).format('DD-MM-YYYY HH:mm:ss Z').replace(/(\+\d{2}):(\d{2})/, '$1$2')
          });
        } else {
          const filterValue = Array.isArray(value) ? value.join(',') : String(value);
          acc.push({
            key: key,
            value: filterValue
          });
        }
      }
      return acc;
    },
      []
    );

    this.filterChange.emit(formattedFilters);
    const activeTabIndex = this.tabService?.activeTab;
    this.tabService.updateFilterData(activeTabIndex, formattedFilters);
    this.searchDropDownToggle = !this.searchDropDownToggle;
  }

  setMonth(event:any){
    const { startDate, endDate } = this.sharedService.getStartAndEndDates(event);
    this.searchForm.controls['FROM_DATE'].setValue(startDate)
    this.searchForm.controls['TO_DATE'].setValue(endDate)
  }

  onReset() {
    // this.searchForm.addControl('WAREHOUSEMAPPING', new FormControl(''));
    
    this.showCustomDateRange = false
    this.selectedOption = "";
    this.searchForm.reset();
    this.resetFilters.emit();
    const activeTabIndex = this.tabService?.activeTab;
    this.tabService.updateFilterData(activeTabIndex, []);
    this.searchDropDownToggle = !this.searchDropDownToggle;
  }

  setId(){
    const obj  = []
    if(this.showZone){
      obj.push(this.allCatagory.Region.id)
    }
    if(this.showDepartment){
      obj.push(this.allCatagory.Department.id)
    }
    if(this.showDesignation){
      obj.push(this.allCatagory.Designation.id)
    }
    if(this.showPriority){
      obj.push(this.allCatagory.Priority.id)
    }
    if(this.showRegion){
      obj.push(this.allCatagory.Region.id)
    }
    if(this.showCity){
      obj.push(this.allCatagory.City.id)
    }
    if(this.showProjectCategory){
      obj.push(this.allCatagory.ProjectCategory.id)
    }
    if(this.showLocationType){
      obj.push(this.allCatagory?.LocationType.id)
    }
    return obj
  }
  getQuickCodeListByCategoryId(ids:any) {
    this.emsServices
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        this.zoneList = data?.responseObject?.Region
        this.designationList = data?.responseObject?.Designation
        this.departmentList = data?.responseObject?.Department 
        this.priorityList = data?.responseObject?.Priority 
        this.regionList = data?.responseObject?.Region
        this.cityList = data?.responseObject?.City
        this.projectCategoryList = data?.responseObject?.ProjectCategory
        this.locationTypeList = data?.responseObject?.LocationType
      });
  }

  getExpenseList(){
    this.emsServices
    .getExpenseList([], 0, 50000,'id','DESC')
    .subscribe((data: any) => {
      this.expenseTypeList = data?.responseObject?.content;
    },err => {
      this.expenseTypeList = []
    });
  }

  getEmployeeList(){
    this.emsServices
    .getEmployees([], 0, 50000,'Id','DESC')
    .subscribe((data: any) => {
      this.employeeLists = data?.responseObject?.content;
    });
  }

  getProjectList(){
    this.emsServices
    .getProjects([], 0, 50000,'Id','DESC')
    .subscribe((data: any) => {
      this.projectLists = data?.responseObject?.content;
    });
  }

  getWorklogStatus(){
    this.worklogService.getWorklogStatus().subscribe((res:any)=>{
      this.worklogStatus = res?.responseObject
    })
  }
  
  getProjectMasterStatusList(){
    this.emsServices.getProjectMasterStatusList().subscribe((res:any)=>{
      this.projectStatus = res.responseObject;
    })
  }

  getWarehouseList(){
    const data = JSON.parse(localStorage.getItem('accountList')!)
      const transformedData  = data;

          
    // Transforming the data
    this.wareHouseList = transformedData.flatMap((item:any) =>
      item.accountWarehouseInfo.map((warehouse:any) => ({
        id: item.id,
        accountName: item.accountName,
        accountCode: item.accountCode,
        accountDescription: item.accountDescription,
        status: item.status,
        warehouseId: warehouse.warehouseId,
        warehouseName: warehouse.warehouseName,
        expenseAssociated: warehouse.expenseAssociated,
      }))
    );

    if(this.searchForm.controls['ACCOUNT_ID_IN'].value){
      this.wareHouseList.forEach((el:any)=>{
        if(el.id == this.searchForm.controls['ACCOUNT_ID_IN'].value && el.warehouseId == this.searchForm.controls['WAREHOUSE_ID_IN'].value){
          this.searchForm.controls['DUMMY_FILTER_ONE'].setValue(el)
        }
      })
    }
  }

  selectWarehouse(event:any){
    console.log(this.searchForm.value.DUMMY_FILTER_ONE)
    const WAREHOUSEMAPPING =
      this.searchForm.value.DUMMY_FILTER_ONE;
    const transformedMapping = Array.isArray(WAREHOUSEMAPPING)
      ? WAREHOUSEMAPPING.map((wh: any) => ({ 
        clientId: wh?.id,
        "warehouseId": wh?.warehouseId
      })) 
      : [];
    const clientIds = transformedMapping.map(item => item.clientId);
    const clientIdString = clientIds.join(',');
    this.searchForm.controls['ACCOUNT_ID_IN'].setValue(clientIdString);
    const warehouseIds = transformedMapping.map(item => item.warehouseId);
    const warehouseIdString = warehouseIds.join(',');
    this.searchForm.controls['WAREHOUSE_ID_IN'].setValue(warehouseIdString);
    console.log(this.searchForm)
  }

  onOptionChange(event: any): void {
    this.selectedOption = event.target.value;
    this.showCustomDateRange = this.selectedOption === 'custom';
  
    if (this.selectedOption !== 'custom') {
      let dateRange = this.sharedService.getPredefinedDateRange(this.selectedOption);
      if (dateRange) {
        this.searchForm.patchValue({
          FROM_DATE: dateRange.startDate,
          TO_DATE: dateRange.endDate
        });
        console.log(dateRange);
      }
    }
  }
  
}
